/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomFieldReference,
    CustomFieldReferenceFromJSON,
    CustomFieldReferenceFromJSONTyped,
    CustomFieldReferenceToJSON,
    Job,
    JobFromJSON,
    JobFromJSONTyped,
    JobToJSON,
    JobReference,
    JobReferenceFromJSON,
    JobReferenceFromJSONTyped,
    JobReferenceToJSON,
    MediaRootPermission,
    MediaRootPermissionFromJSON,
    MediaRootPermissionFromJSONTyped,
    MediaRootPermissionToJSON,
    VolumeReference,
    VolumeReferenceFromJSON,
    VolumeReferenceFromJSONTyped,
    VolumeReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaRootDetail
 */
export interface MediaRootDetail {
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetail
     */
    id: number;
    /**
     * 
     * @type {Array<CustomFieldReference>}
     * @memberof MediaRootDetail
     */
    customFields?: Array<CustomFieldReference>;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaRootDetail
     */
    workflow?: { [key: string]: string | undefined; } | null;
    /**
     * 
     * @type {VolumeReference}
     * @memberof MediaRootDetail
     */
    volume: VolumeReference;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetail
     */
    readonly fullPath: string;
    /**
     * 
     * @type {Array<MediaRootPermission>}
     * @memberof MediaRootDetail
     */
    readonly resolvedPermissions?: Array<MediaRootPermission>;
    /**
     * 
     * @type {Array<Job>}
     * @memberof MediaRootDetail
     */
    readonly workflowJobs: Array<Job>;
    /**
     * 
     * @type {Array<JobReference>}
     * @memberof MediaRootDetail
     */
    jobs?: Array<JobReference>;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaRootDetail
     */
    aiConfig?: { [key: string]: string | undefined; } | null;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetail
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetail
     */
    path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetail
     */
    needsRescan?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetail
     */
    viewMode?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetail
     */
    viewStyle?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetail
     */
    viewDefaultTab?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetail
     */
    showTags?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetail
     */
    showComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetail
     */
    showLocations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetail
     */
    showCustomFields?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetail
     */
    showRatings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetail
     */
    showSubclips?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetail
     */
    showSubtitles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetail
     */
    showMarkers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetail
     */
    showHistory?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetail
     */
    showAiMetadata?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetail
     */
    prefetchThumbnailStrips?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetail
     */
    cover?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetail
     */
    nameField?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetail
     */
    shareComments?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetail
     */
    shareLinkDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetail
     */
    defaultProxyProfile?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetail
     */
    cloudProxyProfile?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetail
     */
    aiConnection?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetail
     */
    aiProxyProfile?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaRootDetail
     */
    proxyProfiles?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaRootDetail
     */
    tags?: Array<number>;
}

export function MediaRootDetailFromJSON(json: any): MediaRootDetail {
    return MediaRootDetailFromJSONTyped(json, false);
}

export function MediaRootDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaRootDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'customFields': !exists(json, 'custom_fields') ? undefined : ((json['custom_fields'] as Array<any>).map(CustomFieldReferenceFromJSON)),
        'workflow': !exists(json, 'workflow') ? undefined : json['workflow'],
        'volume': VolumeReferenceFromJSON(json['volume']),
        'fullPath': json['full_path'],
        'resolvedPermissions': !exists(json, 'resolved_permissions') ? undefined : ((json['resolved_permissions'] as Array<any>).map(MediaRootPermissionFromJSON)),
        'workflowJobs': ((json['workflow_jobs'] as Array<any>).map(JobFromJSON)),
        'jobs': !exists(json, 'jobs') ? undefined : ((json['jobs'] as Array<any>).map(JobReferenceFromJSON)),
        'aiConfig': !exists(json, 'ai_config') ? undefined : json['ai_config'],
        'name': json['name'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'needsRescan': !exists(json, 'needs_rescan') ? undefined : json['needs_rescan'],
        'viewMode': !exists(json, 'view_mode') ? undefined : json['view_mode'],
        'viewStyle': !exists(json, 'view_style') ? undefined : json['view_style'],
        'viewDefaultTab': !exists(json, 'view_default_tab') ? undefined : json['view_default_tab'],
        'showTags': !exists(json, 'show_tags') ? undefined : json['show_tags'],
        'showComments': !exists(json, 'show_comments') ? undefined : json['show_comments'],
        'showLocations': !exists(json, 'show_locations') ? undefined : json['show_locations'],
        'showCustomFields': !exists(json, 'show_custom_fields') ? undefined : json['show_custom_fields'],
        'showRatings': !exists(json, 'show_ratings') ? undefined : json['show_ratings'],
        'showSubclips': !exists(json, 'show_subclips') ? undefined : json['show_subclips'],
        'showSubtitles': !exists(json, 'show_subtitles') ? undefined : json['show_subtitles'],
        'showMarkers': !exists(json, 'show_markers') ? undefined : json['show_markers'],
        'showHistory': !exists(json, 'show_history') ? undefined : json['show_history'],
        'showAiMetadata': !exists(json, 'show_ai_metadata') ? undefined : json['show_ai_metadata'],
        'prefetchThumbnailStrips': !exists(json, 'prefetch_thumbnail_strips') ? undefined : json['prefetch_thumbnail_strips'],
        'cover': !exists(json, 'cover') ? undefined : json['cover'],
        'nameField': !exists(json, 'name_field') ? undefined : json['name_field'],
        'shareComments': !exists(json, 'share_comments') ? undefined : json['share_comments'],
        'shareLinkDuration': !exists(json, 'share_link_duration') ? undefined : json['share_link_duration'],
        'defaultProxyProfile': !exists(json, 'default_proxy_profile') ? undefined : json['default_proxy_profile'],
        'cloudProxyProfile': !exists(json, 'cloud_proxy_profile') ? undefined : json['cloud_proxy_profile'],
        'aiConnection': !exists(json, 'ai_connection') ? undefined : json['ai_connection'],
        'aiProxyProfile': !exists(json, 'ai_proxy_profile') ? undefined : json['ai_proxy_profile'],
        'proxyProfiles': !exists(json, 'proxy_profiles') ? undefined : json['proxy_profiles'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
    };
}

export function MediaRootDetailToJSON(value?: MediaRootDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'custom_fields': value.customFields === undefined ? undefined : ((value.customFields as Array<any>).map(CustomFieldReferenceToJSON)),
        'workflow': value.workflow,
        'volume': VolumeReferenceToJSON(value.volume),
        'jobs': value.jobs === undefined ? undefined : ((value.jobs as Array<any>).map(JobReferenceToJSON)),
        'ai_config': value.aiConfig,
        'name': value.name,
        'path': value.path,
        'needs_rescan': value.needsRescan,
        'view_mode': value.viewMode,
        'view_style': value.viewStyle,
        'view_default_tab': value.viewDefaultTab,
        'show_tags': value.showTags,
        'show_comments': value.showComments,
        'show_locations': value.showLocations,
        'show_custom_fields': value.showCustomFields,
        'show_ratings': value.showRatings,
        'show_subclips': value.showSubclips,
        'show_subtitles': value.showSubtitles,
        'show_markers': value.showMarkers,
        'show_history': value.showHistory,
        'show_ai_metadata': value.showAiMetadata,
        'prefetch_thumbnail_strips': value.prefetchThumbnailStrips,
        'cover': value.cover,
        'name_field': value.nameField,
        'share_comments': value.shareComments,
        'share_link_duration': value.shareLinkDuration,
        'default_proxy_profile': value.defaultProxyProfile,
        'cloud_proxy_profile': value.cloudProxyProfile,
        'ai_connection': value.aiConnection,
        'ai_proxy_profile': value.aiProxyProfile,
        'proxy_profiles': value.proxyProfiles,
        'tags': value.tags,
    };
}


